import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../conf.service';

@Component({
  selector: 'app-campaign-manager',
  templateUrl: './campaign-manager.component.html',
  styleUrls: ['./campaign-manager.component.scss']
})
export class CampaignManagerComponent implements OnInit {

  payloadToSend = {
    partner: '',
    account: '',
    action: '',
    actionTime: '',
    email: '',
  };

  constructor(private route: ActivatedRoute, private confPost: ConfService) { }

  ngOnInit() {
    this.route.queryParams
        .subscribe(params => {
            if (params) {
              if (params.email !== null && params.templateId !== null && params.redirectURL !== null && params.partner !== null && params.account !== null && params.action !== null) {
                this.payloadToSend.partner = params.partner;
                this.payloadToSend.account = params.account;
                this.payloadToSend['templateId'] = params.templateId;
                this.payloadToSend.action = params.action;
                this.payloadToSend.actionTime = this.timeConverter(Date.now());
                this.payloadToSend.email = params.email;
                this.payloadToSend['timestamp'] = (Date.now());
                this.confPost.insertEmailEvent('campaign', 'campaign', 'v1', 'emailActionLogger', this.payloadToSend).subscribe(response => {
                  window.location.href = params.redirectURL;
                });
              }
            }
        });
  }

  timeConverter(ts) {
    let str = '';
    // const ts_ms = ts * 1000;
    // const date_ob = new Date(ts_ms);
    const date_ob = new Date(ts);
    const year = date_ob.getFullYear();
    const month = ('0' + (date_ob.getMonth() + 1)).slice(-2);
    const date = ('0' + date_ob.getDate()).slice(-2);
    const hours = ('0' + date_ob.getHours()).slice(-2);
    const minutes = ('0' + date_ob.getMinutes()).slice(-2);
    const seconds = ('0' + date_ob.getSeconds()).slice(-2);
    str = str + date + '/' + month + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    return str;
  }
}
